import React from "react";
import s from "./index.module.scss";
import Container from "components/layout/Container";

const TechnicalDocuments = (props) => {
    const {
        heading,
        documents,
    } = props.fields;

    return (
        <section className={s.section}>
            <Container>
                <h2>{heading}</h2>
                <ul>
                    {documents.map(({ url, title }) => (
                        <li key={url}>
                            <a target="_blank" rel="noopener noreferrer" href={url}>{title}</a>
                        </li>
                    ))}
                </ul>
            </Container>
        </section>
    );
};

export default TechnicalDocuments;
